<template>
  <div class="navbar">
    <div class="navbar-left">
      <hamburger :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />
      <breadcrumb class="breadcrumb-container" />
    </div>
    <div class="right-menu">
      <div class="user-info">
        <div class="user-avatar-wrap">
          <i class="el-icon-user-solid" />
        </div>
        <el-dropdown trigger="click">
          <span class="user-name-dropdown">
            {{ name }}
            <i class="el-icon-arrow-down" />
          </span>
          <el-dropdown-menu slot="dropdown">
            <router-link to="/">
              <el-dropdown-item icon="el-icon-s-home">首页</el-dropdown-item>
            </router-link>
            <el-dropdown-item divided icon="el-icon-switch-button" @click.native="logout">
              退出登录
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'

export default {
  components: { Breadcrumb, Hamburger },
  computed: {
    ...mapGetters(['sidebar', 'name'])
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      await this.$store.dispatch('user/logout')
      this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px 0 0;
  background: #fff;
  box-shadow: 0 1px 0 #EDF0F7, 0 2px 12px rgba(0,0,0,0.04);
  position: relative;
  z-index: 10;

  .navbar-left {
    display: flex;
    align-items: center;
    height: 100%;
  }

  .hamburger-container {
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0 16px;
    cursor: pointer;
    transition: background 0.3s;
    &:hover { background: rgba(0,0,0,0.03); }
  }

  .breadcrumb-container {
    margin-left: 4px;
  }
}

.right-menu {
  display: flex;
  align-items: center;

  .user-info {
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    padding: 6px 14px;
    border-radius: 30px;
    transition: background 0.2s;
    &:hover { background: #F0F7F4; }
  }

  .user-avatar-wrap {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    background: linear-gradient(135deg, #2D6A4F, #74C69D);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 16px;
    flex-shrink: 0;
  }

  .user-name-dropdown {
    font-size: 14px;
    color: #4A4A6A;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 4px;

    i { font-size: 12px; color: #8A8AAA; }
  }
}
</style>
